import {
  Accordion,
  CustomButton,
  Modal,
  MultiLineInput,
  SvgVerticalSplitter,
} from '@ui-kit'
import { AddNotesModal } from '../AdditionalNotes'
import { TaskNotesType } from '@app-store'
import { STRINGS } from '../../utils/strings'
import { NAMESPACES } from '../../utils/constants'
import { useState } from 'react'
import { useAppSelector, RootState } from '../../utils/agent.store'
import { permissionObject } from '../../utils/helperFunctions'

const TaskNotesSuggestionBox = ({
  task,
  mode,
  setValue,
  register,
  isShowSuggestion,
  isDisabled = false,
}: TaskNotesType) => {
  const [openAddModal, setOpenAddModal] = useState<boolean>(false)
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions?.programPermissions
  )
  const caseData = useAppSelector(
    (state: RootState) => state.workflowData?.caseData
  )
  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)
  const getAccordionHeading = () => {
    return (
      <div className="flex justify-between items-center py-2">
        <span> {STRINGS.NOTES}</span>
        {isShowSuggestion ? (
          <div className="flex gap-4 pr-[0.28rem] items-center">
            <CustomButton
              widthClass="w-[3.25rem]"
              onClick={(e) => {
                e.stopPropagation()
                setOpenAddModal(true)
              }}
              className="!h-7"
              disabled={mode === 'view' || isDisabled}
              onKeyDown={(e) => {
                e.stopPropagation()
                if (e?.key === 'Enter' || e?.key === ' ') setOpenAddModal(true)
              }}
            >
              {NAMESPACES.ADD}
            </CustomButton>
            <SvgVerticalSplitter />
          </div>
        ) : null}
      </div>
    )
  }

  const notesSectionEditable = () => {
    return permissionObject.Manage_Workflow(
      programPermissions,
      caseData,
      task,
      userId ?? ''
    )
  }

  return (
    <div>
      <Accordion heading={getAccordionHeading()} isDefaultActive={true}>
        <div className="w-full p-4">
          <MultiLineInput
            className="w-full border rounded p-4 min-h-20 overflow-y-auto"
            name={`taskNotes${task?.task_id}`}
            widthClass="w-full"
            disabled={mode === 'view' || isDisabled || !notesSectionEditable()}
            register={register}
            id="editing-note"
          />
        </div>
      </Accordion>

      <Modal
        isOpen={openAddModal}
        closeModal={() => setOpenAddModal(false)}
        bodyCssClassName="min-w-[62rem]"
        showCloseButton={false}
      >
        <AddNotesModal
          onSave={(val) => {
            setOpenAddModal(false)
            setValue(`taskNotes${task?.task_id}`, val)
          }}
          onClose={() => setOpenAddModal(false)}
        />
      </Modal>
    </div>
  )
}

export default TaskNotesSuggestionBox
